export class RoutingStates {
  urlNow: string;
  urlNowId: string;
  urlBefore: string;
  urlBeforeId: string;

  constructor(urlNow, urlNowId, urlBefore, urlBeforeId) {
    this.urlNow = urlNow;
    this.urlNowId = urlNowId;
    this.urlBefore = urlBefore;
    this.urlBeforeId = urlBeforeId;
  }
}
